module.exports = __webpack_public_path__ + "static/wallacehanceville-5546d0ec82adbe28c001e1d5ede8aee6.png";